<app-dialog-base [Title]='"Activity"|translate' [dialogId]="dialogId" (onClose)="close()" (onSubmit)="submit()">
  <div class="inputgroupwithimage">
    <label>{{'Photo'|translate}}</label>
    <image-upload #image
        [uploaded]="model.Id ? ['/ctrl/activity/icon/' + this.model.Id]: []">
    </image-upload>
  </div>
  <div class="inputgroup">
    <label>{{'Name'|translate}}</label>
    <input type="text" [(ngModel)]="model.Name" />
  </div>
  <div class="inputgroup">
    <label>{{'Contacts'|translate}}</label>
    <input type="text" [(ngModel)]="model.ContactName" />
  </div>
  <div class="inputgroup">
    <label>{{'Start'|translate}}</label>
    <calendar [name]="'Start'" [(date)]="model.From" [format]="'%0D.%0M.%0Y %0h:%0m'"></calendar>
  </div>
  <div class="inputgroup">
    <label>{{'Finish'|translate}}</label>
    <calendar [name]="'Finish'" [(date)]="model.Till" [format]="'%0D.%0M.%0Y %0h:%0m'"></calendar>
  </div>
  <div class="inputgroup">
    <label>{{'Address'|translate}}</label>
    <input type="text" [(ngModel)]="model.Location" />
  </div>
  <div class="inputgroup">
    <label>{{'Web site'|translate}}</label>
    <input type="text" [(ngModel)]="model.Url" />
  </div>
  <div class="inputgroup">
    <label>{{'Type'|translate}} </label>
    <select [(ngModel)]="model.Type">
      <option value="Bike" [selected]="model.Type == 'Bike'">{{'Bike'|translate}}</option>
      <option value="Kayak" [selected]="model.Type == 'Kayak'">{{'Kayak'|translate}}</option>
      <option value="Orienting" [selected]="model.Type == 'Orienting'">{{'Orienting'|translate}}</option>
      <option value="Running" [selected]="model.Type == 'Running'">{{'Running'|translate}}</option>
      <option value="Trail" [selected]="model.Type == 'Trail'">{{'Trail'|translate}}</option>
    </select>
  </div>
  <div class="inputgroup">
    <label>{{'Distance'|translate}}</label>
    <label>
      <input type="text" placeholder="" [ngModel]="model.Distance | localizeKMeters" (ngModelChange)="convertDistance($event)" />
      <span>{{'km'|localizeUnits}}</span>
    </label>
  </div>
</app-dialog-base>
